import { connect } from 'react-redux'
import { selectAccountSubdomain } from 'selectors/app'
import Attachment from './view'

const select = state => ({
  subdomain: selectAccountSubdomain(state),
})

export default connect(select, null)(Attachment)
